import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import LearningContentInnerWrapper from './LearningContentInnerWrapper';
import { HasGate } from '../../accounts/components/HasGate';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BOTTOM_SPACING = '1000';
export const LearningContentPageLayout = ({
  header,
  navigation,
  children
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const content = /*#__PURE__*/_jsxs(View, {
    paddingBlockEnd: navigation || isMobile ? undefined : BOTTOM_SPACING,
    children: [header, navigation ? /*#__PURE__*/_jsxs(Flex, {
      borderColor: !isMobile ? 'border-core-default' : undefined,
      borderStyle: !isMobile ? 'solid' : undefined,
      borderWidth: !isMobile ? '100' : undefined,
      flexDirection: isMobile ? 'column-reverse' : 'row',
      children: [navigation, /*#__PURE__*/_jsx(View, {
        inlineSize: "100%",
        marginBlockEnd: BOTTOM_SPACING,
        overflow: "hidden",
        children: children
      })]
    }) : children]
  });
  return /*#__PURE__*/_jsx(HasGate, {
    fallback: content,
    gate: "Academy:UnifiedAcademy:Navigation",
    children: /*#__PURE__*/_jsx(LearningContentInnerWrapper, {
      children: content
    })
  });
};
export default LearningContentPageLayout;